let tokens = {
    idToken: null,
    accessToken: null,
    refreshToken: null,
    tokenExpiration: null,
    authProvider: 'cognito' // Default to 'cognito', can be 'cognito' or 'entra'
};

export const tokenStorage = {
    /**
     * Set active auth provider and store tokens in memory
     */
    setTokens: (idToken, accessToken, refreshToken, expiresIn, provider = 'cognito') => {
        tokens.idToken = idToken;
        tokens.accessToken = accessToken;
        tokens.refreshToken = refreshToken;
        tokens.tokenExpiration = Date.now() + (expiresIn * 1000);
        tokens.authProvider = provider;

        // Persist provider preference across page reloads
        localStorage.setItem('authProvider', provider);
    },

    getIdToken: () => tokens.idToken,
    getAccessToken: () => tokens.accessToken,
    getRefreshToken: () => tokens.refreshToken,
    getAuthProvider: () => tokens.authProvider || localStorage.getItem('authProvider') || 'cognito',

    isTokenExpired: () => {
        // Add 5-minute buffer for proactive token refresh
        return !tokens.tokenExpiration || tokens.tokenExpiration - 300000 < Date.now();
    },

    clearTokens: () => {
        tokens.idToken = null;
        tokens.accessToken = null;
        tokens.refreshToken = null;
        tokens.tokenExpiration = null;
        tokens.authProvider = 'cognito';
        localStorage.removeItem('authProvider');
    }
};